<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3 class="font-weight-bold" v-text="'Master Values'"></h3>
              <v-spacer></v-spacer>
              <v-btn v-can:edit="'value_lists'"
                :loading="isSaving"
                :disabled="isSaving"
                rounded
                color="primary"
                @click="save"
              >
                Save
              </v-btn>
            </v-card-title>
            <page-loader :loading="isFetching" />
            <v-card-text>
              <v-row>
                <v-col>
                  <v-autocomplete
                    @change="getData"
                    ref="value"
                    rounded
                    color="primary"
                    hide-details
                    :loading="isLoading"
                    class="white--text"
                    v-model="value_id"
                    :items="valueItems"
                    label="Select Value"
                    prepend-inner-icon="mdi-format-list-text"
                    solo
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="value_id">
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <v-simple-table
                fixed-header
                :height="`${valueLists.length ? '370px' : ''}`"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Description</th>
                      <th class="text-left">Code</th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-center action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(valueList, i) in valueLists"
                      :key="`valueList${i}`"
                    >
                      <td>{{ i + 1 }}</td>
                      <td>
                        <v-col class="px-0">
                          <v-text-field
                            v-model="valueList.description"
                            outlined
                            dense
                            label="Description"
                            :input="
                              (valueList.description =
                                valueList.description.toUpperCase())
                            "
                            hide-details="auto"
                            :error-messages="
                              valueList.description == ''
                                ? 'this description field is required'
                                : ''
                            "
                          ></v-text-field>
                        </v-col>
                      </td>
                      <td>
                        <v-col class="px-0">
                          <v-text-field
                            :error-messages="
                              valueList.code == ''
                                ? 'this code field is required'
                                : ''
                            "
                            v-model="valueList.code"
                            :input="
                              (valueList.code = valueList.code.toUpperCase())
                            "
                            outlined
                            dense
                            label="Code"
                            hide-details="auto"
                          ></v-text-field>
                        </v-col>
                      </td>

                      <td style="min-width: 160px">
                        {{ formatDate(valueList.created_at) }}
                      </td>
                      <td class="text-right">
                        <div class="text-center">
                          <v-tooltip bottom v-if="!valueList.id">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'value_lists'"
                                v-bind="attrs"
                                v-on="on"
                                small
                                color="primary"
                                icon
                                @click="deleteValueList(valueList)"
                              >
                                <v-icon>mdi-delete-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Delete</span>
                          </v-tooltip>
                          <v-tooltip bottom v-else>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'value_lists'"
                                v-bind="attrs"
                                v-on="on"
                                small
                                color="primary"
                                icon
                                @click="delete_data(valueList.id)"
                              >
                                <v-icon>mdi-delete-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Delete</span>
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr v-if="value_id">
                      <td colspan="4"></td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </v-card-text>
            <v-card-actions>
              <v-row>
                <v-col class="mx-5 my-2">
                  <v-btn v-can:add="'value_lists'"
                    v-if="value_id"
                    outlined
                    block
                    rounded
                    color="primary"
                    @click="addEmptyValueList()"
                  >
                    Add New Row
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "ValueListsPage",
  data() {
    return {
      value_id: "",
      valueItems: [],
      valueLists: [],
      excel_fields: {
        "Sr No": "sr_no",
        DESCRIPTION: "description",
        CODE: "code",
      },
      title: "",
      value_list_excel: [],
      isLoading: false,
      isFetching: false,
      isSaving: false,
    };
  },

  async mounted() {

    this.isFetching = true;

    try {
      await this.getMasters();

    } finally {

      this.isFetching = false;

    }

  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    async getMasters() {
      let masters = await axios.get("masters?context=value_list");
      masters = masters.data;
      masters.values.forEach((value) => {
        this.valueItems.push({
          id: value.id,
          text: value.name,
          value: value.id,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let valueLists = await axios.get(`/values/${this.value_id}/value_lists`);
      this.valueLists = valueLists.data.data;
      this.count = valueLists.data.count;
      this.isLoading = false;
      this.exportToExcel();
    },
    exportToExcel() {
      let value_name = this.valueItems.find(
        (valueItem) => valueItem.id === this.value_id
      );
      this.title = "List of " + value_name.text;
      this.value_list_excel = [];
      let sr_no = 1;
      this.valueLists.forEach((valuelist) => {
        this.value_list_excel.push({
          sr_no: sr_no,
          description: valuelist.description,
          code: valuelist.code,
        });
        sr_no++;
      });
    },
    searchData() {
      this.getData();
    },
    addEmptyValueList() {
      this.valueLists.push({
        value_id: this.value_id,
        company_id: this.company.id,
        description: "",
        code: "",
        is_active: 1,
      });
    },
    async save() {
      if (this.valueLists.length > 0) {
        this.isSaving = true;
        let payload = {
          datas: this.valueLists,
        };

        let response = await axios.post(
          `/values/${this.value_id}/multiple_value_lists`,
          payload
        );
        this.valueLists = response.data.data;
        this.isSaving = false;
      }
    },
    deleteValueList(valueList, index) {
      // Check if both description and code are empty
      if (!valueList.description.trim() && !valueList.code.trim()) {
        // If both are empty, simply remove the row from the valueLists array
        this.valueLists.splice(index, 1);
      } else {
        // If at least one field is not empty, proceed with the API call
        this.delete_data(valueList.id, index);
      }
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(
            `/values/${this.value_id}/value_lists/delete/${this.encryptIt(
              id
            )}`
          );
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
